import {
  InformerModalRoot,
  InformerModalContent,
  InformerModalCloseButton,
  InformerModalBody,
  InformerModalMedia,
  InformerModalTitle,
  InformerModalDescription,
  InformerModalAction,
  useDeviceInfo,
} from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import cn from 'clsx';

import * as s from './DealsLeadFormResultModal.css';

export type TDealsLeadFormResultModalStatus = 'success' | 'error';

export interface IDealsLeadFormResultModalProps {
  status: TDealsLeadFormResultModalStatus | null;
  onClose(): void;
}

const CONTENT_BY_STATUS: Record<TDealsLeadFormResultModalStatus, { title: string; description: string }> = {
  success: {
    title: 'Скоро перезвоним',
    description: 'С 9 до 21 по мск менеджер позвонит вам, чтобы обсудить детали',
  },
  error: {
    title: 'Что-то пошло не так',
    description: 'Попробуйте позже',
  },
};

/**
 * Экран результата отправки заявки продукта "Циан Сделки" — успех/ошибка
 */
export const DealsLeadFormResultModal = ({ status, onClose }: IDealsLeadFormResultModalProps) => {
  const { isPhone } = useDeviceInfo();

  if (!status) {
    return null;
  }

  const { title, description } = CONTENT_BY_STATUS[status];

  return (
    <InformerModalRoot open onOpenChange={onClose} modal>
      <InformerModalContent size="S">
        <InformerModalCloseButton
          theme="fill_light"
          size="XS"
          icon={<IconActionClose16 color="current_color" />}
          title="Закрыть"
        />

        <InformerModalBody>
          <InformerModalMedia
            className={cn(s['image'], status === 'success' ? s['image-success'] : s['image-error'])}
          />
          <InformerModalTitle>{title}</InformerModalTitle>
          <InformerModalDescription>{description}</InformerModalDescription>

          <div className={s['actions']}>
            <InformerModalAction fullWidth={isPhone} size="M">
              Хорошо
            </InformerModalAction>
          </div>
        </InformerModalBody>
      </InformerModalContent>
    </InformerModalRoot>
  );
};
